(function() {
    'use strict';

    angular.module( APP_ID )
        .directive( 'autoscrollActivator', [ '$timeout', '$window', 'LoggerFactory', 'AutoscrollService',  AutoscrollActivatorDirective ] );


    /**
     * Activates auto-scrolling.
     *
     * Important: *MUST BE* called as late as possible to function reliably.
     *
     * @param {ng.ITimeoutService} $timeout
     * @param {ng.IWindowService} $window
     * @param {LoggerFactory} LoggerFactory
     * @param {AutoscrollService} AutoscrollService
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function AutoscrollActivatorDirective(
        $timeout,
        $window,
        LoggerFactory,
        AutoscrollService
    ){





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'AutoscrollActivatorDirective' );


        /** @const */
        var SUBPAGE_HTML_ID = 'tab-content';


        /** @type {ng.IDirective} */
        var directiveConfig = {
            restrict:    'E',
            link:        link
        };



        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ////////////////////////////////////////////////////////////////////////



        /**
         * @type {ng.IDirectiveLinkFn}
         *
         * @param {ng.IScope} $scope
         */
        function link( $scope ) {





            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function init(){
                AutoscrollService.redefineLinkStateProcessor( defineTabbedPageScrollingProcessor );
                setWatchers();
            })();





            /* ===== PRIVATE FUNCTIONS ====================================== */


            function setWatchers() {
                // On $contentLoad trigger.
                $scope.$watch( function() { return $scope.$parent.$parent.vm.isContentReady; } , function( isContentLoaded ) {
                    if ( isContentLoaded ) {
                        AutoscrollService.performAutoscroll();
                    }
                });
            }


            /**
             * Retrieves HTML-based ID of an element to which should the
             * autoscroll be performed in case of standard link routing
             * action.
             *
             * @param {uirouter.Transition} $transition
             *
             * @returns {string} HTML-based ID of an element autoscroll should scroll to after loading.
             */
            function defineTabbedPageScrollingProcessor( $transition ) {
                logger.debug( 'Customising the scroll to anchor: #%s [standard link *only*]', SUBPAGE_HTML_ID, $transition );
                return SUBPAGE_HTML_ID;
            }


        }



    }
})();
